var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5C4.84476 10.5 2.48348 11.7755 0.980165 13.755C0.656611 14.181 0.494834 14.394 0.500126 14.6819C0.504214 14.9043 0.644597 15.1849 0.820496 15.3222C1.04817 15.5 1.36368 15.5 1.99469 15.5H13.0053C13.6363 15.5 13.9518 15.5 14.1795 15.3222C14.3554 15.1849 14.4958 14.9043 14.4999 14.6819C14.5052 14.394 14.3434 14.181 14.0198 13.755C12.5165 11.7755 10.1552 10.5 7.5 10.5Z",
    fill: "#441A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8C9.58166 8 11.2692 6.32107 11.2692 4.25C11.2692 2.17893 9.58166 0.5 7.5 0.5C5.41834 0.5 3.73083 2.17893 3.73083 4.25C3.73083 6.32107 5.41834 8 7.5 8Z",
    fill: "#441A98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5C4.84476 10.5 2.48348 11.7755 0.980165 13.755C0.656611 14.181 0.494834 14.394 0.500126 14.6819C0.504214 14.9043 0.644597 15.1849 0.820496 15.3222C1.04817 15.5 1.36368 15.5 1.99469 15.5H13.0053C13.6363 15.5 13.9518 15.5 14.1795 15.3222C14.3554 15.1849 14.4958 14.9043 14.4999 14.6819C14.5052 14.394 14.3434 14.181 14.0198 13.755C12.5165 11.7755 10.1552 10.5 7.5 10.5Z",
    stroke: "#441A98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8C9.58166 8 11.2692 6.32107 11.2692 4.25C11.2692 2.17893 9.58166 0.5 7.5 0.5C5.41834 0.5 3.73083 2.17893 3.73083 4.25C3.73083 6.32107 5.41834 8 7.5 8Z",
    stroke: "#441A98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.6b0c8ddacfd2e153d19f42b9dec831ff.svg";
export { ForwardRef as ReactComponent };